import { ColDef } from "ag-grid-community";
import { PlanRegion } from "src/app/generated-models/PlanRegion";
import { ColParams } from "src/app/shared/grid/ag-grid";
import { LinkCellComponent } from "src/app/shared/grid/link-cell.component";
import * as CDs from "src/app/utility/commonColDef";

export const pfPlanEditorCellComponentParams = {
    target: "_blank",
    url: (params: ColParams<PlanRegion, string>) => `/quota/pf/services/${params.data.ServiceTreeId}/editor`,
  };

export const reviewApprovablePfPlanCellComponentParams = {
    value: "Review",
    target: "_blank",
    url: (params: ColParams<PlanRegion, string>) =>
      `/quota/pf/services/${params.data.ServiceTreeId}/versions/${params.data.Version}/review`,
  };
export const PfPlansColumnDefinition: ColDef[] = [
    {
      ...CDs.ServiceTreeId,
      cellRenderer: LinkCellComponent,
      cellRendererParams: pfPlanEditorCellComponentParams,
    },
    CDs.ServiceTeam,
    CDs.Ring,
    CDs.LatestCommitVersion,
    CDs.SubmitTime("Submit Time", "CreatedTime"),
    CDs.CreatedBy,
    CDs.Status,
    CDs.CustomFilter
  ];

  export const ApprovablePfPlansColumnDefinition: ColDef[] = [
    {
      headerName: "Action",
      colId: "action",
      sortable: false,
      suppressMenu: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      cellRenderer: LinkCellComponent,
      cellRendererParams: reviewApprovablePfPlanCellComponentParams,
    },
    CDs.Ring,
    CDs.ServiceTeam,
    CDs.ServiceTreeId,
    {
      ...CDs.Version,
      //cellRenderer: LinkCellComponent,
      // cellRendererParams: viewRegionalPlanDetailCellComponentParams,
    },
    {
      "headerName": "Submitter",
      "field": "CreatedBy"
    },
    CDs.SubmitTime("Submit Time", "CreatedTime"),
    CDs.Status,
    CDs.CustomFilter
  ];

export const PfFfpGrowthFormulasColumnDefinition: ColDef[] = [
  {
    ...CDs.ServiceTreeId,
    cellRenderer: LinkCellComponent,
    cellRendererParams: pfPlanEditorCellComponentParams,
  },
  CDs.ServiceTeam,
  CDs.Email,
  {
    headerName: "Manatree Name",
    field: "ManatreeName",
    sortable: true,
    filter: true
  },
  {
    headerName: "Component Name",
    field: "ComponentName",
    sortable: true,
    filter: true
  },
  {
    headerName: "Scope Type",
    field: "ScopeType",
    sortable: true,
    filter: true
  },
  {
    headerName: "Distribution Type",
    field: "DistributionType",
    sortable: true,
    filter: true
  },
  {
    headerName: "Baseline",
    field: "Baseline",
    type: "numericColumn",
    sortable: true,
    filter: "agNumberColumnFilter"
  },
  {
    headerName: "Baseline 2",
    field: "Baseline2",
    type: "numericColumn",
    sortable: true,
    filter: "agNumberColumnFilter"
  },
  {
    headerName: "Baseline 3",
    field: "Baseline3",
    type: "numericColumn",
    sortable: true,
    filter: "agNumberColumnFilter"
  },
  {
    headerName: "Growth Coefficient",
    field: "GrowthCoefficient",
    type: "numericColumn",
    sortable: true,
    filter: "agNumberColumnFilter"
  },
  {
    headerName: "Offset",
    field: "Offset",
    type: "numericColumn",
    sortable: true,
    filter: "agNumberColumnFilter"
  },
  {
    headerName: "Resource Type",
    field: "ResourceType",
    sortable: true,
    filter: true
  },
  {
    headerName: "Required SKUs",
    field: "RequiredSkus",
    sortable: true,
    filter: true
  },
  {
    headerName: "Dependencies",
    field: "Dependencies",
    sortable: true,
    filter: true
  }
];
